<template>
    <b-container fluid>
       <b-row>
          <b-col sm="12">
               <card>
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Manage General Sliders</h4>
                  </template>
                  <template v-slot:headerAction>
                     <div class="float-right">
                        <b-button v-b-modal.add-modal variant="primary">Add Slider</b-button>
                     </div>
                  </template>
                  <template v-slot:body>
                     <!----- Listing length starts ----->
                     <div class="row listing-length-row">
                        <div class="col-sm-12 col-md-6">
                           <div class="listing-length">
                              <label>Show 
                                 <select class="form-control" v-model="listing_length" @change="fetchSliders()">

                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    
                                 </select> entries
                              </label>
                           </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                           <div class="div-search">
                              <label>
                                 <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchSliders()" />
                              </label>
                           </div>
                        </div>
                     </div>
                     <!----- Listing length ----->
                     
                     <!--- listing starts ------>
                     <div class="table-responsive">
                        <table id="datatable" class="table data-table table-striped table-bordered dataTable" >
                           <thead>
                              <tr>
                                 <th>ID</th>
                                 <th>Image</th>
                                 <th>Status</th>
                                 <th>Options</th>                                 
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="slider in sliders" :key="slider.id">
                                 <td>{{slider.slider_id}}</td>
                                 <td><img :src="$image_url + slider.image" alt="Image not found" style="width:150px;"></td>
                                 <td>
                                    <label v-if="slider.status==1">Active</label>
                                    <label v-else>Blocked</label>
                                 </td>
                                    
                                 <td>
                                    <!-- <router-link :to="{name: 'slider.clicks', params: { id: slider.id }}" class="btn btn-sm btn-primary mt-2 mr-1" >{{slider.clicks}} Clicks <i class="fas fa-angle-double-right"></i></router-link> -->

                                    <a href="#" class="btn btn-sm btn-primary mt-2 mr-1" @click.prevent="setBackURL(slider.id)">{{slider.clicks}} Clicks <i class="fas fa-angle-double-right"></i></a>

                                    <b-button variant="danger" class="btn-sm mt-2 mr-1" @click="deactivateSlider(slider)" v-if="slider.status==1">Deactivate</b-button>
                                    <b-button variant="success" class="btn-sm mt-2 mr-1" @click="activateSlider(slider)" v-else>Activate</b-button>  
                                    <b-button variant="danger" class="btn-sm mt-2 mr-1" @click="deleteSlider(slider.id)">Delete</b-button>
                                 </td>
                              </tr>
                           </tbody>                           
                        </table>
                     </div>
                     <!---- listing ends -------->

                     <!--- modal starts ---->
                     <b-modal ref="add-modal" id="add-modal" title="Add Slider" hide-footer @hidden="clearForm()">   
                        <b-form @submit.prevent="addSlider" enctype="multipart/form-data">
                           <b-col md="12" class="form-group">
                              <label class="control-label">Image <span class="required">*</span> <span class="note">[Allowed Formats: jpg, jpeg, png]</span></label>     
                              <input type="file" @change="setFile"  accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" id="fileinput">
                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback"> 
                                 <p class="mb-0">{{val}}</p>
                              </div> 
                              <img class="image-preview" v-bind:src="preview_image">
                           </b-col>
                           <b-col md="12">
                              <b-button type="submit" class="mr-3" variant="primary">Add</b-button>
                              <b-button class="" variant="light" @click="hideModal">Close</b-button>                          
                           </b-col>
                        </b-form>
                     </b-modal>
                     <!---- modal ends ----->

                     <!----pagination starts --->
                     <nav aria-label="Page navigation">                    
                        <ul class="pagination">
                           <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                              <a class="page-link" href="#" @click.prevent="fetchSliders(page.url + '&limit='+ listing_length + '&keyword=' + keyword)" tabindex="-1">
                                 <span v-if="index == 0">Prev</span>
                                 <span v-else-if="index == pagination.length-1">Next</span>
                                 <span v-else>{{page.label}}</span>
                              </a>
                           </li>                        
                        </ul>
                     </nav>
                     <!----pagination ends --->
                  </template>
                  
               </card>
          </b-col>
       </b-row>
    </b-container>
</template>
<script>
export default {
   name:'GeneralSliders',
   data() {
      return {
         sliders: [],
         
         image: null,
         preview_image: null,
         pagination: {},
         slider_status: {
            id: "",
            status: ""
         },
         keyword: "",
         showsearch: false,
         listing_length: 10,
         token: '',
         errors: {},
         delete: false,
         activate: false,
         deactivate: false,

         active_page_url: null,
      };
   },
   mounted () {
      //this.fetchSliders();
      //window.$('#datatable').DataTable();
   },

   created() {
      this.fetchSliders();
   },

   methods: {
      fetchSliders(page_url=null) {
         this.getToken();
         let url = '/api/admin/sliders?limit=' + this.listing_length + "&keyword=" + this.keyword;
         page_url = page_url || url; 

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url; 
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
                    this.sliders = responseData.data;
                    this.pagination = responseData.links;
            })
            .catch(err => console.log(err));
      },

      getToken() {
         if(localStorage.token) {
            this.token = localStorage.token;
         } else {
            this.$vToastify.error('Session expired, please login again');
            this.$router.push({name: 'auth.login'})
         }
      },

      setBackURL(slider_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'slider.general.clicks', params: { id: slider_id } });
      },

      setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(this.image);
      },

      addSlider(){
         this.getToken();              
         let formData = new FormData();                  
         formData.append('image', this.image);
                     
         const config = {
              headers: {
                  'content-type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + this.token,
              }
         };
          this.$axios
          .post('/api/admin/sliders/add', formData, config)
          .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.clearForm();
              this.hideModal();
              this.fetchSliders();
          })
          .catch(error => {
              if(error.response){
                  if(error.response.data.message){
                     this.errors = error.response.data.message;
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
          });
               
       },

       clearForm() {
            
            this.image = null;
            this.preview_image = null;            
            this.errors = {};
            document.getElementById('fileinput').value = '';
      },

      hideModal() {
        this.$refs['add-modal'].hide()
      },

      deleteSlider(slider_id) {
         this.delete = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to delete this slide?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
         })
         .then(value => {
            this.delete = value
            if(this.delete){
               this.getToken();
               this.$axios
                  .get("/api/admin/sliders/delete?slider_id=" + slider_id,{headers: {Authorization: 'Bearer ' + this.token,}})
                  .then(response => {
                     if(response.data.status) {
                           this.$vToastify.success(response.data.message);
                     } else {
                           this.$vToastify.error(response.data.message);
                     }
                     
                     this.fetchSliders();
                  })
                  .catch(err => console.log(err));
            }
         })
         .catch(err => {
            console.log(err);
         })         
      },

      activateSlider(slider) {
         this.activate = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to activate this slide?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
         })
         .then(value => {
            this.activate = value
            if(this.activate){
               this.slider_status.id = slider.id;
               this.slider_status.status = '1';
               this.updateSliderStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },

      deactivateSlider(slider) {
         this.deactivate = false;
         this.$bvModal.msgBoxConfirm('Are you sure you want to deactivate this slide?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
         })
         .then(value => {
            this.deactivate = value
            if(this.deactivate){
               this.slider_status.id = slider.id;
               this.slider_status.status = '0';
               this.updateSliderStatus();
            }
         })
         .catch(err => {
            console.log(err);
         })
      },
      
      updateSliderStatus() {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .get('/api/admin/sliders/status?slider_id=' + this.slider_status.id + '&status=' + this.slider_status.status, config)
         .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.fetchSliders(this.active_page_url);
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
               
          });
      }
   }   
}
</script>